import { useCallback, useEffect, useRef, useState } from "react";
import { Grid2 } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MyWorlist from "./MyWorklist";
import WorkItemDetails from "./WorkItemDetails";
import PrescriptionForm from "../Prescriptions/PrescriptionForm";
import LaparoscopyPrescriptionForm from "../Prescriptions/LaproscopyPrescriptionForm";

import PhysiotherapyTreatmentNotes from "./PhysioTherapyTreatmentNotes";
import PhysiotherapyPrescriptionForm from "../Prescriptions/PhysiotherapyPrescriptionForm";
import NoteTypeDialog from "./NoteTypeDialogue";
import Typography from "@mui/material/Typography";
import MedicalRecord from "./MedicalRecord";
import GeneralNote from "./GeneralNote";
import GeneralPrescriptionForm from "../Prescriptions/GeneralPrescriptionForm";
import PrescriptionReadOnlyView from "../Prescriptions/PrescriptionReadOnlyView";
import { PrescriptionTypes } from "../Utility/Constants";
//import LaproscopyNote from "./LaproscopyNote";

function MyWorklistHome() {
  const workItemDetailsRef = useRef();

  // Initialize state for tab numbers
  const [newPrescriptionTabNumber, setNewPrescriptionTabNumber] = useState(0);
  const [newMedicalRecordTabNumber, setNewMedicalRecordTabNumber] = useState(0);
  const [newNoteTabNumber, setNewNoteTabNumber] = useState(0);

  // State for note type dialog
  const [noteDialogOpen, setNoteDialogOpen] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState(null);

  // Initialize tabs with local storage
  const [tabs, setTabs] = useState(() => {
    const savedTabs = localStorage.getItem("myworklist-tabs");
    return savedTabs
      ? JSON.parse(savedTabs)
      : [{ label: "Worklist", value: "Worklist", type: "Worklist" }];
  });

  // Initialize active tab with local storage
  const [value, setValue] = useState(() => {
    const savedActiveTab = localStorage.getItem("myworklist-active-tab");
    return savedActiveTab || "Worklist";
  });

  // Save tabs to local storage whenever tabs change
  useEffect(() => {
    localStorage.setItem("myworklist-tabs", JSON.stringify(tabs));
  }, [tabs]);

  // Save active tab to local storage whenever it changes
  useEffect(() => {
    localStorage.setItem("myworklist-active-tab", value);
  }, [value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const handleEditPrescription = (serviceId, prescriptionDetails) => {
  //   setTabs((prevTabs) => {
  //     const existingTab = prevTabs.find(
  //       (tab) => tab.value === prescriptionDetails.id
  //     );

  //     if (existingTab) {
  //       setValue(existingTab.value);
  //       return prevTabs;
  //     } else {
  //       const newTab = {
  //         label: prescriptionDetails?.displayId,
  //         value: prescriptionDetails?.id,
  //         type: "EditPrescription",
  //         serviceId: serviceId,
  //         prescriptionId: prescriptionDetails?.id,
  //         prescriptionType: prescriptionDetails.prescriptionType,
  //       };

  //       setValue(prescriptionDetails?.id);
  //       return [...prevTabs, newTab];
  //     }
  //   });
  // };

  // const handleEditNote = (serviceId, noteDetails) => {
  //   setTabs((prevTabs) => {
  //     const existingTab = prevTabs.find((tab) => tab.value === noteDetails.id);

  //     if (existingTab) {
  //       setValue(existingTab.value);
  //       return prevTabs;
  //     } else {
  //       const newTab = {
  //         label:
  //           noteDetails?.displayId ||
  //           (noteDetails.noteType === "General"
  //             ? "General Note"
  //             : "Physio Note"),
  //         value: noteDetails?.id,
  //         type:
  //           noteDetails.noteType === "General"
  //             ? "EditGeneralNote"
  //             : "EditPhysioNote",
  //         serviceId: serviceId,
  //         noteId: noteDetails?.id,
  //       };

  //       setValue(noteDetails?.id);
  //       return [...prevTabs, newTab];
  //     }
  //   });
  // };
  const handleEditPrescription = (serviceId, prescriptionDetails) => {
    setTabs((prevTabs) => {
      const existingTab = prevTabs.find(
        (tab) => tab.value === prescriptionDetails.id
      );

      if (existingTab) {
        setValue(existingTab.value);
        return prevTabs;
      } else {
        const newTab = {
          label: prescriptionDetails?.displayId,
          value: prescriptionDetails?.id,
          type: "EditPrescription",
          serviceId: serviceId,
          prescriptionId: prescriptionDetails?.id,
          prescriptionType: prescriptionDetails.prescriptionType,
        };

        setValue(prescriptionDetails?.id);
        return [...prevTabs, newTab];
      }
    });
  };

  const openPrescriptionViewTab = (
    prescriptionId,
    prescriptionDisplayId,
    prescriptionType
  ) => {
    setTabs((prevTabs) => {
      const existingTab = tabs.find((tab) => tab.value === prescriptionId);
      if (existingTab) {
        setValue(existingTab.value);
      } else {
        const newTab = {
          label: prescriptionDisplayId || "Prescription",
          value: prescriptionId,
          type: "ViewPrescription",
          prescriptionId: prescriptionId,
          prescriptionType: prescriptionType,
        };

        setValue(prescriptionId);
        return [...prevTabs, newTab];
      }
      return prevTabs;
    });
  };

  const handleEditNote = (serviceId, noteDetails) => {
    setTabs((prevTabs) => {
      const existingTab = prevTabs.find((tab) => tab.value === noteDetails.id);
console.log(noteDetails.noteType)
      if (existingTab) {
        setValue(existingTab.value);
        return prevTabs;
      } else {
        let tabLabel;
        let tabType;

        if (noteDetails.noteType === "General") {
          tabLabel = noteDetails?.displayId || "General Note";
          tabType = "EditGeneralNote";
        } else if (noteDetails.noteType === "PhysiotherapyTreatment") {
          tabLabel = noteDetails?.displayId || "Physio Note";
          tabType = "EditPhysioNote";

        //   tabType = "EditLaproscopyNote";
        // } else {
        //   tabLabel = noteDetails?.displayId || "Note";
        //   tabType = "EditGeneralNote";
        }

        const newTab = {
          label: tabLabel,
          value: noteDetails?.id,
          type: tabType,
          serviceId: serviceId,
          noteId: noteDetails?.id,
        };

        setValue(noteDetails?.id);
        return [...prevTabs, newTab];
      }
    });
  };
  const handleEditMedicalRecord = (serviceId, recordDetails) => {
    setTabs((prevTabs) => {
      const existingTab = prevTabs.find(
        (tab) => tab.value === recordDetails.id
      );

      if (existingTab) {
        setValue(existingTab.value);
        return prevTabs;
      } else {
        const newTab = {
          label: recordDetails?.displayId || "Medical Record",
          value: recordDetails?.id,
          type: "EditMedicalRecord",
          serviceId: serviceId,
          recordId: recordDetails?.id,
        };

        setValue(recordDetails?.id);
        return [...prevTabs, newTab];
      }
    });
  };

  // Callback for adding a note - opens the dialog
  const handleAddNote = useCallback((serviceId) => {
    setSelectedServiceId(serviceId);
    setNoteDialogOpen(true);
  }, []);

  // Handler for note type selection
  // const handleNoteTypeSelect = (noteType) => {
  //   setNewNoteTabNumber((prevTabNumber) => {
  //     const newTabNumber = prevTabNumber + 1;
  //     const newTab = {
  //       label:
  //         noteType === "General"
  //           ? newTabNumber === 1
  //             ? "General Notes"
  //             : `General Notes ${newTabNumber}`
  //           : newTabNumber === 1
  //           ? "Physio Notes"
  //           : `Physio Notes ${newTabNumber}`,
  //       value: `AddNote-${noteType}-${newTabNumber}`,
  //       type: noteType === "General" ? "AddGeneralNote" : "AddPhysioNote",
  //       serviceId: selectedServiceId,
  //     };

  //     setTabs((prevTabs) => [...prevTabs, newTab]);
  //     setValue(`AddNote-${noteType}-${newTabNumber}`);

  //     return newTabNumber;
  //   });
  //   setNoteDialogOpen(false);
  // };
  const handleNoteTypeSelect = (noteType) => {
    setNewNoteTabNumber((prevTabNumber) => {
      const newTabNumber = prevTabNumber + 1;

      let tabLabel;
      let tabType;

      switch (noteType) {
        case "General":
          tabLabel =
            newTabNumber === 1
              ? "General Notes"
              : `General Notes ${newTabNumber}`;
          tabType = "AddGeneralNote";
          break;
        case "Physiotherapy":
          tabLabel =
            newTabNumber === 1
              ? "Physio Notes"
              : `Physio Notes ${newTabNumber}`;
          tabType = "AddPhysioNote";
          break;

        default:
          tabLabel = "Notes";
          tabType = "AddGeneralNote";
      }

      const newTab = {
        label: tabLabel,
        value: `AddNote-${noteType}-${newTabNumber}`,
        type: tabType,
        serviceId: selectedServiceId,
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setValue(`AddNote-${noteType}-${newTabNumber}`);

      return newTabNumber;
    });
    setNoteDialogOpen(false);
  };

  // Callback for adding a medical record
  const handleAddMedicalRecord = useCallback((serviceId) => {
    setNewMedicalRecordTabNumber((prevTabNumber) => {
      const newTabNumber = prevTabNumber + 1;
      const newTab = {
        label:
          newTabNumber === 1
            ? "Add Medical Record"
            : `Add Medical Record ${newTabNumber}`,
        value: `AddMedicalRecord-${newTabNumber}`,
        type: "AddMedicalRecord",
        serviceId: serviceId,
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setValue(`AddMedicalRecord-${newTabNumber}`);

      return newTabNumber;
    });
  }, []);

  const handleViewDetails = (serviceDetails) => {
    const existingTab = tabs.find((tab) => tab.value === serviceDetails.id);

    if (existingTab) {
      setValue(existingTab.value);
    } else {
      const newTab = {
        label: serviceDetails?.displayId,
        value: serviceDetails?.id,
        type: "WorkItemDetails",
        serviceId: serviceDetails?.id,
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setValue(serviceDetails?.id);
    }
  };

  const handleNewPrescription = useCallback(
    (serviceId, prescriptionType = PrescriptionTypes.GeneralPrescription) => {
      setNewPrescriptionTabNumber((prevTabNumber) => {
        const newTabNumber = prevTabNumber + 1;

        let tabLabel;

        if (prescriptionType === PrescriptionTypes.GeneralPrescription) {
          tabLabel =
            newTabNumber === 1
              ? "New Prescription"
              : `New Prescription ${newTabNumber}`;
        } else if (prescriptionType === PrescriptionTypes.PhysiotherapyPrescription) {
          tabLabel =
            newTabNumber === 1
              ? "New Physio Prescription"
              : `New Physio Prescription ${newTabNumber}`;
        }
        // } else if (prescriptionType === "General2") {
        //   tabLabel =
        //     newTabNumber === 1
        //       ? "New General Prescription"
        //       : `New General Prescription ${newTabNumber}`;
        // }

        const newTab = {
          label: tabLabel,
          value: `NewPrescription-${prescriptionType}-${newTabNumber}`,
          type: "NewPrescription",
          serviceId: serviceId,
          tabNumber: newTabNumber,
          prescriptionType: prescriptionType,
        };

        setTabs((prevTabs) => [...prevTabs, newTab]);
        setValue(`NewPrescription-${prescriptionType}-${newTabNumber}`);

        return newTabNumber;
      });
    },
    []
  );

  const handleCloseTab = (tabValue) => {
    if (tabValue === "Worklist") return;

    setTabs((prevTabs) => prevTabs.filter((tab) => tab.value !== tabValue));
    if (value === tabValue) {
      setValue("Worklist");
    }
  };

  const handleDeletePrescription = (serviceId, prescriptionId) => {
    setTabs((prevTabs) => {
      const updatedTabs = prevTabs.filter(
        (tab) => tab.value !== prescriptionId
      );
      const existingTab = updatedTabs.find((tab) => tab.value === serviceId);

      if (existingTab) {
        setValue(existingTab.value);
        workItemDetailsRef.current?.refreshPrescriptions();
      } else {
        setValue("Worklist");
      }

      return updatedTabs;
    });
  };

  const handleDeleteNote = (serviceId, noteId) => {
    setTabs((prevTabs) => {
      const updatedTabs = prevTabs.filter((tab) => tab.value !== noteId);
      const existingTab = updatedTabs.find((tab) => tab.value === serviceId);

      if (existingTab) {
        setValue(existingTab.value);
        workItemDetailsRef.current?.refreshClinicalNotes();
      } else {
        setValue("Worklist");
      }

      return updatedTabs;
    });
  };

  const handleDeleteMedicalRecord = (serviceId, recordId) => {
    setTabs((prevTabs) => {
      const updatedTabs = prevTabs.filter((tab) => tab.value !== recordId);
      const existingTab = updatedTabs.find((tab) => tab.value === serviceId);

      if (existingTab) {
        setValue(existingTab.value);
        workItemDetailsRef.current?.refreshMedicalRecords();
      } else {
        setValue("Worklist");
      }

      return updatedTabs;
    });
  };

  const handleSavePrescription = (
    serviceId,
    prescriptionId,
    prescriptionStatus
  ) => {
    setTabs((prevTabs) => {
      if (prescriptionStatus === "Final") {
        const updatedTabs = prevTabs.filter(
          (tab) => tab.value !== prescriptionId
        );
        const existingTab = updatedTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          setValue(existingTab.value);
          workItemDetailsRef.current?.refreshPrescriptions();
        } else {
          setValue("Worklist");
        }
        return updatedTabs;
      } else {
        const existingTab = prevTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          workItemDetailsRef.current?.refreshPrescriptions();
        }
        return prevTabs;
      }
    });
  };

  const handleSaveNote = (serviceId, noteId, noteStatus) => {
    setTabs((prevTabs) => {
      if (noteStatus === "Final") {
        const updatedTabs = prevTabs.filter((tab) => tab.value !== noteId);
        const existingTab = updatedTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          setValue(existingTab.value);
          workItemDetailsRef.current?.refreshClinicalNotes();
        } else {
          setValue("Worklist");
        }
        return updatedTabs;
      } else {
        const existingTab = prevTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          workItemDetailsRef.current?.refreshClinicalNotes();
        }
        return prevTabs;
      }
    });
  };

  const handleSaveMedicalRecord = (serviceId, recordId, recordStatus) => {
    setTabs((prevTabs) => {
      if (recordStatus === "Final") {
        // If record is finalized, close the tab
        const updatedTabs = prevTabs.filter((tab) => tab.value !== recordId);
        const existingTab = updatedTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          setValue(existingTab.value);
          workItemDetailsRef.current?.refreshMedicalRecords();
        } else {
          setValue("Worklist");
        }
        return updatedTabs;
      } else {
        // If draft, just refresh the list
        const existingTab = prevTabs.find((tab) => tab.value === serviceId);
        if (existingTab) {
          workItemDetailsRef.current?.refreshMedicalRecords();
        }
        return prevTabs;
      }
    });
  };

  return (
    <Grid2 container>
      <NoteTypeDialog
        open={noteDialogOpen}
        onClose={() => setNoteDialogOpen(false)}
        onSelect={handleNoteTypeSelect}
      />

      <TabContext value={value}>
        <Grid2
          container
          size={12}
          sx={{ borderBottom: "1px solid lightgray", width: "100%" }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.value}
                sx={{ paddingLeft: "5px" }}
                label={
                  <Grid2 container size={12}>
                    <Grid2 size={11} sx={{ alignContent: "center" }}>
                      {tab.label}
                    </Grid2>
                    <Grid2 size={1}>
                      {tab.value !== "Worklist" && (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCloseTab(tab.value);
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Grid2>
                  </Grid2>
                }
                value={tab.value}
              />
            ))}
          </Tabs>
        </Grid2>

        {/* Worklist Tab */}
        <TabPanel
          key="Worklist"
          value="Worklist"
          sx={{ padding: "0px", width: "100%" }}
          keepMounted
        >
          <MyWorlist
            onViewDetails={handleViewDetails}
            onAddNewPrescription={handleNewPrescription}
            onAddNote={handleAddNote}
            onAddMedicalRecord={handleAddMedicalRecord}
          />
        </TabPanel>

        {/* Dynamic tabs */}
        {tabs
          .filter((tab) => tab.value !== "Worklist")
          .map((tab) => (
            <TabPanel
              key={tab.value}
              value={tab.value}
              sx={{ padding: "0px", width: "100%" }}
              keepMounted
            >
              {tab.type === "WorkItemDetails" && (
                <WorkItemDetails
                  ref={workItemDetailsRef}
                  key={tab.serviceId}
                  serviceId={tab.serviceId}
                  onEditPrescription={handleEditPrescription}
                  onAddNewPrescription={handleNewPrescription}
                  onAddNote={handleAddNote}
                  onViewNote={handleEditNote}
                  onAddMedicalRecord={handleAddMedicalRecord}
                  onViewMedicalRecord={handleEditMedicalRecord}
                />
              )}
              {tab.type === "EditPrescription" &&
                tab.prescriptionType === "General2" && (
                  <PrescriptionForm
                    key={tab.prescriptionId}
                    serviceId={tab.serviceId}
                    prescriptionId={tab.prescriptionId}
                    onRemovePrescription={handleDeletePrescription}
                    onSavePrescription={handleSavePrescription}
                  />
                )}
              {tab.type === "EditPrescription" &&
                tab.prescriptionType === PrescriptionTypes.PhysiotherapyPrescription && (
                  <PhysiotherapyPrescriptionForm
                    key={tab.prescriptionId}
                    serviceId={tab.serviceId}
                    prescriptionId={tab.prescriptionId}
                    onRemovePrescription={handleDeletePrescription}
                    onSavePrescription={handleSavePrescription}
                  />
                )}
              {tab.type === "ViewPrescription" && (
                <PrescriptionReadOnlyView
                  key={tab.prescriptionId}
                  prescriptionId={tab.prescriptionId}
                  prescriptionType={tab.prescriptionType}
                />
              )}
              {tab.type === "NewPrescription" &&
                tab.prescriptionType === "General2" && (
                  <PrescriptionForm
                    key={tab.tabNumber}
                    serviceId={tab.serviceId}
                    mode="new"
                    onSavePrescription={handleSavePrescription}
                  />
                )}
              {tab.type === "NewPrescription" &&
                tab.prescriptionType === PrescriptionTypes.PhysiotherapyPrescription && (
                  <PhysiotherapyPrescriptionForm
                    key={tab.tabNumber}
                    serviceId={tab.serviceId}
                    mode="new"
                    onSavePrescription={handleSavePrescription}
                  />
                )}
              {tab.type === "AddGeneralNote" && (
                <GeneralNote
                  key={tab.serviceId}
                  serviceId={tab.serviceId}
                  onSaveNote={handleSaveNote}
                  onRemoveNote={handleDeleteNote}
                />
              )}
              {tab.type === "AddPhysioNote" && (
                <PhysiotherapyTreatmentNotes
                  key={tab.serviceId}
                  serviceId={tab.serviceId}
                  onSaveNote={handleSaveNote}
                  onRemoveNote={handleDeleteNote}
                />
              )}
              {tab.type === "EditGeneralNote" && (
                <GeneralNote
                  key={tab.noteId}
                  serviceId={tab.serviceId}
                  noteId={tab.noteId}
                  onSaveNote={handleSaveNote}
                  onRemoveNote={handleDeleteNote}
                />
              )}
              {tab.type === "EditPhysioNote" && (
                <PhysiotherapyTreatmentNotes
                  key={tab.noteId}
                  serviceId={tab.serviceId}
                  noteId={tab.noteId}
                  onSaveNote={handleSaveNote}
                  onRemoveNote={handleDeleteNote}
                />
              )}
              {tab.type === "AddMedicalRecord" && (
                <MedicalRecord
                  key={`add-medical-record-${tab.serviceId}`}
                  availedServiceId={tab.serviceId}
                  onSaveMedicalRecord={handleSaveMedicalRecord}
                  onRemoveMedicalRecord={handleDeleteMedicalRecord}
                />
              )}
              {tab.type === "EditMedicalRecord" && (
                <MedicalRecord
                  key={`edit-medical-record-${tab.recordId}`}
                  availedServiceId={tab.serviceId}
                  recordId={tab.recordId}
                  onSaveMedicalRecord={handleSaveMedicalRecord}
                  onRemoveMedicalRecord={handleDeleteMedicalRecord}
                />
              )}

              {tab.type === "EditPrescription" &&
                tab.prescriptionType === PrescriptionTypes.GeneralPrescription && (
                  <LaparoscopyPrescriptionForm
                    key={tab.prescriptionId}
                    serviceId={tab.serviceId}
                    prescriptionId={tab.prescriptionId}
                    onRemovePrescription={handleDeletePrescription}
                    onSavePrescription={handleSavePrescription}
                  />
                )}

              {tab.type === "NewPrescription" &&
                tab.prescriptionType === PrescriptionTypes.GeneralPrescription && (
                  <LaparoscopyPrescriptionForm
                    key={tab.tabNumber}
                    serviceId={tab.serviceId}
                    mode="new"
                    onSavePrescription={handleSavePrescription}
                  />
                )}
            </TabPanel>
          ))}
      </TabContext>
    </Grid2>
  );
}

export default MyWorklistHome;
